import jQuery from "jquery";
import gsap from 'gsap';

export default jQuery(document).ready(function ($) {

    const sliders = document.querySelectorAll(".ex-person-slider-vertical");

    const initSlider = slider => {
        const SLIDE_TIME = 10000;
        let currentTime = SLIDE_TIME;
        let timer = {};
        let currentSlide = 1;
        const slidesCount = slider.querySelectorAll(".slide-wrapper").length - 1;
        const navButtons = slider.querySelectorAll(".slider-navigation a");


        const hideSlide = () => {
            return new Promise(resolve => {
                const sliderWrapper = slider.querySelector(".slide-wrapper");

                gsap.to(sliderWrapper, {
                    alpha: 0, duration: .3, onComplete: () => {
                        sliderWrapper.innerhtml = '';
                        resolve();
                    }
                });

            });
        }

        const showSlide = slideNum => {
            slideNum = Number(slideNum);

            return new Promise(resolve => {
                const ANIM_DURATION = .8;
                const newSlide = slider.querySelector(`.slide-wrapper:nth-of-type(${slideNum + 1})`);
                const slideWrapper = slider.querySelector(".slide-wrapper");
                slideWrapper.innerHTML = newSlide.innerHTML;

                const img = slideWrapper.querySelector(".person-img");
                const description = slideWrapper.querySelector(".slide-content");
                gsap.to(slideWrapper, {alpha: 1, duration: ANIM_DURATION});
                gsap.fromTo(img, {x: -20}, {x: 0, duration: ANIM_DURATION});
                gsap.fromTo(description, {y: 20}, {y: 0, duration: ANIM_DURATION, onComplete: resolve});

            });
        }

        const changeSlide = slideNum => {

            if (slideNum === currentSlide) {
                return;
            }

            removeNavListeners()
            setActiveButton(slideNum - 1);
            hideSlide()
                .then(() => showSlide(slideNum))
                .then(() => {
                    currentSlide = slideNum;
                    startTimer();
                    attachNavListeners();
                })

        }
        const onNavClick = event => {
            event.preventDefault();
            const button = event.target;
            changeSlide(button.dataset.slide)
        }

        const showNexSlide = () => {
            let slideToShow = currentSlide + 1;

            if (slideToShow > slidesCount) {
                slideToShow = 1;
            }

            changeSlide(slideToShow);
        }

        const clearTimer = () => {
            clearInterval(timer);
            currentTime = SLIDE_TIME;
        }

        const pauseTimer = () => {
            clearInterval(timer);
        }

        const resumeTimer = () => {
            startTimer(currentTime);
        }

        const tick = () => {
            currentTime -= 1000;
            if (currentTime <= 0) {
                showNexSlide();
                clearTimer();
            }
        }

        const startTimer = (time = SLIDE_TIME) => {
            clearInterval(timer);
            currentTime = time;
            timer = setInterval(tick, 1000);
        }

        const attachNavListeners = () => {
            [...navButtons].map(btn => btn.addEventListener("click", onNavClick));
        }

        const removeNavListeners = () => {
            [...navButtons].map(btn => btn.removeEventListener("click", onNavClick));
        }

        const attachHoverListeners = () => {
            slider.addEventListener("mouseenter", pauseTimer);
            slider.addEventListener("mouseleave", resumeTimer);
        }

        const setActiveButton = buttonNum => {
            [...navButtons].map(x => x.classList.remove('active'));
            navButtons[buttonNum].classList.add('active');
        }

        startTimer();
        attachNavListeners();
        attachHoverListeners();
    }

    for (const slider of sliders) {
        initSlider(slider);
    }

});